import { pushGtmEvent } from './gtmEvents'

/**
 * "Book a call" with Raghav (free Calendly plan: no GA4 integration, no redirect after booking).
 * The widget opens as a popup in the app; bookings are tracked from Calendly's own postMessage events.
 */
export var CALENDLY_BOOKING_URL = 'https://calendly.com/raghav-tiwari-sentrykit/30min?hide_gdpr_banner=1&utm_source=app&utm_medium=connect_page&utm_campaign=connect_help'

var CALENDLY_ORIGIN = 'https://calendly.com'
var WIDGET_CSS = 'https://assets.calendly.com/assets/external/widget.css'
var WIDGET_JS = 'https://assets.calendly.com/assets/external/widget.js'

var pending = null
var lastSource = 'connect'
var trackingRegistered = false

/** Loads the widget once, on first click (keeps /connect fast). +onError+ runs if it can't load. */
export function loadCalendly (cb, onError) {
  if (window.Calendly) return cb()
  if (pending) {
    pending.push({ cb: cb, onError: onError })
    return
  }
  pending = [{ cb: cb, onError: onError }]
  var link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = WIDGET_CSS
  document.head.appendChild(link)
  var script = document.createElement('script')
  script.src = WIDGET_JS
  script.async = true
  script.onload = function () {
    var queue = pending
    pending = null
    queue.forEach(function (q) { q.cb() })
  }
  script.onerror = function () {
    var queue = pending
    pending = null
    // Remove the failed tag so a later click retries.
    if (script.parentNode) script.parentNode.removeChild(script)
    queue.forEach(function (q) { if (q.onError) q.onError() })
  }
  document.head.appendChild(script)
}

/**
 * Opens the booking popup with name + email prefilled, so the seller only picks a time.
 * Falls back to the booking page in a new tab if the widget can't load (blocked, offline).
 */
export function openCalendlyBooking (prefill, source) {
  lastSource = source || 'connect'
  pushGtmEvent({ event: 'connect_call_click', source: lastSource })
  var p = prefill || {}
  var widgetPrefill = {}
  if (p.name) widgetPrefill.name = p.name
  if (p.email) widgetPrefill.email = p.email
  loadCalendly(function () {
    window.Calendly.initPopupWidget({ url: CALENDLY_BOOKING_URL, prefill: widgetPrefill })
  }, function () {
    window.open(CALENDLY_BOOKING_URL, '_blank', 'noopener')
  })
}

/** Turns Calendly's iframe messages into dataLayer events. Register once (main.js). */
export function registerCalendlyTracking () {
  if (trackingRegistered) return
  trackingRegistered = true
  window.addEventListener('message', function (e) {
    if (e.origin !== CALENDLY_ORIGIN || !e.data || !e.data.event) return
    if (e.data.event === 'calendly.date_and_time_selected') pushGtmEvent({ event: 'calendly_time_selected', source: lastSource })
    if (e.data.event === 'calendly.event_scheduled') pushGtmEvent({ event: 'calendly_booked', source: lastSource })
  })
}



// WEBPACK FOOTER //
// ./src/utils/calendly.js